<template>
  <div>
    <div class="row">
      <div class="col-sm">
        <div class="form-group">
          <label class="mb-0">
            <p class="text-primary">No. Vigilancia</p>
          </label>
        </div>
      </div>

      <div class="col-sm">
        <div class="form-group">
          <label class="mb-0">
            <p class="text-primary">Fecha</p>
          </label>
        </div>
      </div>
    </div>
    <div class="row" v-if="show_date1">
      <div class="col-sm">
        <div class="form-group">Vigilancia 1</div>
      </div>

      <div class="col-sm">
        <div class="form-group">
          <app-input
            type="date"
            v-model="date_vi1"
            placeholder="Fecha"
            :disabled="true"
          />
        </div>
      </div>
    </div>

    <div class="row" v-if="show_date2">
      <div class="col-sm">
        <div class="form-group">Vigilancia 2</div>
      </div>

      <div class="col-sm">
        <div class="form-group">
          <app-input
            type="date"
            v-model="date_vi2"
            placeholder="Fecha"
            :disabled="true"
          />
        </div>
      </div>
    </div>
    <div class="row" v-if="show_date3">
        <div class="col-sm">
          <div class="form-group">
            Vigilancia 3
          </div>
        </div>

        <div class="col-sm">
          <div class="form-group">
            <app-input
              type="date"
              v-model="date_vi3"
              placeholder="Ingrese Fecha"
              :disabled="true"
            />
          </div>
        </div>
      </div>
    <div class="row" v-if="show_date4">
      <div class="col-sm">
        <div class="form-group">Renovación</div>
      </div>

      <div class="col-sm">
        <div class="form-group">
          <app-input
            type="date"
            v-model="date_ren"
            placeholder="Fecha"
            :disabled="true"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { axiosGet } from "@/app/helpers/AxiosHelper";
export default {
  mixins: [FormMixin],

  data() {
    return {
      date_vi1: null,
      date_vi2: null,
      date_vi3: null,
      date_ren: null,
      show_date1: false,
      show_date2: false,
      show_date3: false,
      show_date4: false,
    };
  },
  filters: {
    dateFormat: function (value) {
      return moment(value).format("YYYY-MM-DD HH:mm");
    },
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      let url = `/historical/accreditation/getMaintenance/${this.$store.state.common.accAppId}`;
      axiosGet(url)
        .then((response) => {
            var maintenances = response.data;
            if (maintenances) {
                for (var i = 0; i < maintenances.length; i++) {
                  let date1 = moment(maintenances[i].maintenance_date).format(
                    "YYYY-MM-DD HH:mm"
                  );
                  if (maintenances[i].accreditation_type_id == 6) {
                    this.date_vi1 = new Date(date1);
                    this.show_date1 = true;
                  } else if (maintenances[i].accreditation_type_id == 7) {
                    this.date_vi2 = new Date(date1);
                    this.show_date2 = true;
                  } else if (maintenances[i].accreditation_type_id == 8) {
                    this.date_vi3 = new Date(date1);
                    this.show_date3 = true;
                  } else if (maintenances[i].accreditation_type_id == 9) {
                    this.date_ren = new Date(date1);
                    this.show_date4 = true;
                  }
                }
            }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style></style>
